<template>
	<span>
		<v-fade-transition mode="out-in">
			<v-card class="elevation-6 hidden-sm-and-down" style="width: 85%">
				<router-link :to="'/event/'+ event.slug">
					<div class="ribbon2" v-if="event.event_key == 'promotion'"><span>{{ $t('ribbon_promote') }}</span></div>
					<div class="ribbon3" v-if="event.event_key == 'sold_out'"><span>{{ $t('ribbon_sold') }}</span></div>
					<div class="ribbon6" v-if="event.event_key == 'public'"><span>{{ $t('ribbon_public') }}</span></div>
					<v-img  height="120" :src="getEventImage(event.eventImages)" :lazy-src="getEventImage(event.eventImages)" v-if="$route.name == 'home'">
					</v-img>
					<v-img  height="120" :src="getEventImage(event.eventImages)" :lazy-src="getEventImage(event.eventImages)" v-else>
						<template v-slot:placeholder>
							<v-row class="fill-height ma-0" align="center" justify="center">
								<v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
							</v-row>
						</template>
					</v-img>
					<v-card-title class="title-text">
						{{event.town_code}}
					</v-card-title>
					<div class="num" align="center">
						{{event.name | capitalize}}
					</div>
				</router-link>
				<div class="pad">
					<v-icon color="grey" small>mdi-thumb-up</v-icon>
					<span class="black--text ml-1 font-weight-bold small_num">410</span>
					<v-divider class="mx-1" inset vertical></v-divider>
					<v-icon color="grey" small>mdi-thumb-down</v-icon>
					<span class="black--text ml-1 font-weight-bold small_num">411</span>
					<v-divider class="mx-2" inset vertical></v-divider>
					<v-icon color="blue lighten-2" small v-if="event.moment == 'night'">mdi-moon-waning-crescent</v-icon>
					<v-icon color="red lighten-2" small v-if="event.moment == 'day'">mdi-white-balance-sunny</v-icon>
				</div>
				<div class="pad font-weight-bold small_num">
					{{ event.date }}
				</div>
				<div class="pad font-weight-bold" style="height: 30px;"> 
					<span v-if="event.price ==='0'"><b>Free</b></span>
					<span v-else>{{event.price | currency('K ') }}</span> |
					<span v-if="event.price ==='0'">
						<v-tooltip bottom v-if="userIsAuthenticated">
							<template v-slot:activator="{ on }">
								<span v-on="on">
									<v-btn color="black" dark x-small rounded @click="addToEventCart">
										<v-icon small>mdi-registered-trademark</v-icon>
									</v-btn>
								</span>
							</template>
							<span>
								{{ $t('event_free_remain') }} <br>
								27 {{ $t('event_free_remain') }}
							</span>
						</v-tooltip>
						<v-tooltip bottom v-if="!userIsAuthenticated">
							<template v-slot:activator="{ on }">
								<span v-on="on">
									<v-btn color="grey" dark x-small rounded @click="goToSignIn">
										<v-icon small>mdi-registered-trademark</v-icon>
									</v-btn>
								</span>
							</template>
							<span>{{ $t('event_signin') }}</span>
						</v-tooltip>
					</span>
					<span v-else> 
						<v-tooltip bottom v-if="userIsAuthenticated">
							<template v-slot:activator="{ on }">
								<span v-on="on">
									<v-btn color="black" dark x-small rounded @click="addToEventCart">
										<v-icon small>mdi-cart</v-icon>
									</v-btn>
								</span>
							</template>
							<span>{{ $t('event_cart') }}</span>
						</v-tooltip>
						<v-tooltip bottom v-if="!userIsAuthenticated">
							<template v-slot:activator="{ on }">
								<span v-on="on">
									<v-btn color="grey" dark x-small rounded @click="goToSignIn">
										<v-icon small>mdi-cart</v-icon>
									</v-btn>
								</span>
							</template>
							<span>{{ $t('event_signin') }}</span>
						</v-tooltip>
					</span>
				</div>
			</v-card>
		</v-fade-transition>
		<v-fade-transition mode="out-in">
			<v-card class="elevation-6 hidden-md-and-up"  style="width: 85%">
				<router-link :to="'/event/'+ event.slug">
					<!-- <div class="ribbon" v-if="event.event_key == 'discount'"><span>Big Sale</span></div>
					<div class="ribbon1" v-if="event.event_key == 'discount'"><span>Low Price</span></div> -->
					<div class="ribbon2" v-if="event.event_key == 'promotion'"><span>{{ $t('ribbon_promote') }}</span></div>
					<div class="ribbon3" v-if="event.event_key == 'sold_out'"><span>{{ $t('ribbon_sold') }}</span></div>
					<div class="ribbon4" v-if="event.event_key == 'public'"><span>{{ $t('ribbon_public') }}</span></div>
					<!-- <div class="ribbon5" v-if="event.event_key == 'discount'"><span>High Review</span></div>
					<div class="ribbon6" v-if="event.event_key == 'discount'"><span>High Rating</span></div> -->
					<v-img  height="100" :src="getEventImage(event.eventImages)" :lazy-src="getEventImage(event.eventImages)">
						<template v-slot:placeholder>
							<v-row class="fill-height ma-0" align="center" justify="center">
								<v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
							</v-row>
						</template>
					</v-img>
					<v-card-title class="title-text-mini">
						{{event.town_code}}
					</v-card-title>
					<div class="num" align="center" style="min-height: 30px">
						<b>{{event.name | capitalize}}</b>
					</div>
				</router-link>
				<div class="pad font-weight-bold small_num">
					{{ event.date }}
				</div>
				<div class="pad font-weight-bold" style="height: 30px;"> 
					{{event.price | currency('K ') }} | 
					<v-tooltip bottom v-if="userIsAuthenticated">
						<template v-slot:activator="{ on }">
							<span v-on="on">
								<v-btn color="black" dark x-small rounded @click="addToEventCart">
									<v-icon small>mdi-cart</v-icon>
								</v-btn>
							</span>
						</template>
						<span>{{ $t('event_cart') }}</span>
					</v-tooltip>
					<v-tooltip bottom v-if="!userIsAuthenticated">
						<template v-slot:activator="{ on }">
							<span v-on="on">
								<v-btn color="grey" dark x-small rounded @click="goToSignIn">
									<v-icon small>mdi-cart</v-icon>
								</v-btn>
							</span>
						</template>
						<span>{{ $t('event_signin') }}</span>
					</v-tooltip>
				</div>
			</v-card>
		</v-fade-transition>
	</span>
</template>

<script>
	import {fb,db} from '@/firebase'
  export default {
    props: {
      event: {
        required: true,
        type: Object
      }
    },
    data: () => ({
      quantityValue: 1
    }),
    created(){
      this.uid = fb.auth().currentUser.uid

      db.collection('user').where('user_id','==',fb.auth().currentUser.uid).get()
      .then(snapshot=>{
        snapshot.forEach(doc => {
          this.user =doc.data()
          this.user.id = doc.id
        })
      })
    },
    methods: {
      getEventImage(eventImages){
        return eventImages[0]
      },

      goToSignIn(){
        this.$router.push('/signin')
      },

      goToSignInI(){
        this.$router.push({ 
          name: 'signin_alt', 
          params: { slug: this.product.slug }
        })
      },

      addToEventCart(){
      this.total = ((this.quantityValue)*(this.event.price))
        db.collection('cartitems').add({
            event_name: this.event.name,
            event_image: this.event.eventImages,
            event_price: this.event.price,
            client_name: this.event.client,
            client_town: this.event.town_code,
            event_quantity: this.quantityValue,
            event_total: this.total,
            event_id: this.event.id,
            user: this.user
        }).then(() => {
        /* eslint-disable */
        Toast.fire({
          type: 'success',
          title: 'event added to cart'
        })
        }).catch(err => {
            console.log(err);
        })
        /* eslint-enable */
      }
    },

    computed: {
      userIsAuthenticated () {
        return this.uid !== null && this.uid !== undefined
      }
    }
  }
</script>

<style scoped>
.pad {
	padding-left: 5px;
}
.num {
	min-height: 30px;
	font-size: 16px;
	word-break: normal;
	line-height: 1.0
}
.small_num {
	font-size: 14px;
}
.title-text {
	color: white;
	float: right;
	position: absolute;
	top: 80px;
	font-size: 15px;
}
.title-text-mini {
	color: white;
	float: right;
	position: absolute;
	top: 60px;
	font-size: 15px;
}
</style>
